// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fS0VaAoyfQHCJz {
  margin-bottom: 16px;
  display: inline-block;
  padding: 0;
  background: transparent;
  text-decoration: underline;
}
.fS0VaAoyfQHCJz:focus {
  outline: -webkit-focus-ring-color auto 5px;
}
@-moz-document url-prefix() {
  .fS0VaAoyfQHCJz:focus {
    outline: black dotted 1px;
  }
}
.fS0VaAoyfQHCJz:hover {
  background-color: transparent;
}
.fS0VaAoyfQHCJz:active {
  background-color: transparent;
}
.zWdfYVKHwMsVPO {
  color: var(--ds-text-subtle, #44546f);
}
.zWdfYVKHwMsVPO:hover {
  background-color: transparent;
  color: var(--ds-text, #172b4d);
}
.tFJcn3ayjxbHjk {
  color: var(--ds-text-inverse, #ffffff);
  z-index: 2;
}
.tFJcn3ayjxbHjk:hover {
  color: var(--ds-text-inverse, #ffffff);
}
.t1Adspc2w3teps {
  margin: 4px 0;
}
.yMjJPZKPIKWPXc {
  margin-top: 4px;
  margin-bottom: 16px;
}
.BRLEbRD0cZadv_ {
  margin-top: 8px;
}
.y1cLmBnFBnH3_J {
  margin: 0 auto;
  width: calc(100% - 2px);
}
.mBjkMxn77iaItD {
  margin-right: 30px;
  background: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: default;
  text-align: left;
}
.mBjkMxn77iaItD:hover {
  background: none;
  color: var(--ds-text-disabled, #091e424f);
}
.mBjkMxn77iaItD:active {
  background: none;
  color: var(--ds-text-disabled, #091e424f);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cta": `fS0VaAoyfQHCJz`,
	"lightModeCta": `zWdfYVKHwMsVPO`,
	"darkModeCta": `tFJcn3ayjxbHjk`,
	"boardMenuPromptFullWrapper": `t1Adspc2w3teps`,
	"butlerUpsellPopoverPromptFullWrapper": `yMjJPZKPIKWPXc`,
	"createBoardModalWrapper": `BRLEbRD0cZadv_`,
	"memberHomeScreenPromptFullWrapper": `y1cLmBnFBnH3_J`,
	"disabledCta": `mBjkMxn77iaItD`
};
export default ___CSS_LOADER_EXPORT___;
